export enum Enemizer {
    None = 0,
    Limited = 1,
    Balanced = 2,
    Full = 3,
    Insane = 4,
}
